import { render, staticRenderFns } from "./Transmision.vue?vue&type=template&id=7c28912c"
import script from "./Transmision.vue?vue&type=script&lang=js"
export * from "./Transmision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports